export const FEATURES = [
  { id: "home", label: "Home", description: "Panel overview, key metrics, and recent activity.", paths: ["/home"] },
  { id: "studies", label: "Studies & Insights", description: "Studies, research findings, and cross-study analysis.", paths: ["/studies", "/insights"] },
  { id: "data-explorer", label: "Data Explorer", description: "Explore survey responses and saved data views.", paths: ["/data-explorer"] },
  { id: "crosstabs", label: "Crosstabs", description: "Compare results across groups and build tables.", paths: ["/crosstabs"] },
  { id: "dashboards", label: "Dashboards", description: "Create and explore visual research dashboards.", paths: ["/dashboards"] },
  { id: "panelist-finder", label: "Panelist Finder", description: "Find qualified panelists and check availability.", paths: ["/scheduling"] },
  { id: "communications", label: "Communications", description: "Manage communications with panel members.", paths: ["/communication"] },
  { id: "chat-with-panel", label: "Chat with Panel", description: "Ask questions and explore the panel through chat.", paths: ["/chat-with-panel"] },
  { id: "panelists", label: "Panelists", description: "Browse panel members and manage their profiles.", paths: ["/panelists"] },
  { id: "automation", label: "Automation", description: "Configure and manage automated workflows.", paths: ["/automation"] },
] as const;

export type FeatureId = typeof FEATURES[number]["id"];
export type FeatureFlags = Record<FeatureId, boolean>;
export type FeatureAvailability = { version: 1; features: FeatureFlags; updated_at: string | null };

export const FEATURE_DISABLED_MESSAGE = "This feature is currently disabled in preparation for training and onboarding. You will receive personalized training when this feature is enabled.";

export function featureForPath(path: string): typeof FEATURES[number] | undefined {
  if (path === "/tools" || path.startsWith("/tools/") || path.startsWith("/auth/")) return undefined;
  if (path === "/") return FEATURES[1]; // App redirects the root to Studies.
  return FEATURES.find((feature) => feature.paths.some((prefix) => path === prefix || path.startsWith(`${prefix}/`)))
    || FEATURES[0]; // Unknown routes render Home in App.
}

export function parseFeatureAvailability(value: unknown): FeatureAvailability {
  const data = value as FeatureAvailability | null;
  if (!data || data.version !== 1 || !data.features || typeof data.features !== "object"
    || Object.keys(data.features).length !== FEATURES.length
    || FEATURES.some(({ id }) => typeof data.features[id] !== "boolean")
    || (data.updated_at !== null && typeof data.updated_at !== "string")) {
    throw new Error("The server returned invalid feature availability settings.");
  }
  return data;
}
